import {
    superCall as _$su,
    className as _$cn,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
} from 'intact';
import {makeStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {placement, overlay, resizable, width} = this.get();
    const {
        getResizeBarPosition, getHeightResizeBarPosition, 
        drawerWidth, isResizing, drawerHeight, startWidth, startHeight
    } = this._resizable;
    const shouldShowHeightResizeBar = !!(resizable && (placement === 'top' || placement === 'bottom'))
    
    const { k } = this.config;
    const classNameObj = {
        [`${k}-drawer`]: true,
        [`${k}-${placement}`]: true,
        [makeStyles(overlay, k)]: true
    };
    
    return _$su.call($this, {
        'className': _$cn(classNameObj),
        'width': resizable ? (drawerWidth.value || width) : width
    }, function($blocks) {
        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
        return (
            (
                (_$blocks['_content'] = function($super) {
                    return (
                        _$ce(2, 'div', [
                            $super(),
                            (!!resizable) ?
                                _$ce(2, 'div', null, 1 /* HasInvalidChildren */, _$cn(`${k}-drawer-resize ${k}-drawer-resize-${getResizeBarPosition()}`), {
                                    'ev-mousedown': startWidth
                                }) :
                                undefined,
                            (shouldShowHeightResizeBar) ?
                                _$ce(2, 'div', null, 1 /* HasInvalidChildren */, _$cn(`${k}-drawer-resize-horizontal ${k}-drawer-resize-${getHeightResizeBarPosition()}`), {
                                    'ev-mousedown': startHeight
                                }) :
                                undefined
                        ], 0 /* UnknownChildren */, _$cn(`${k}-drawer-content ${isResizing.value ? `${k}-drawer-resizing` : ''}`), {
                            'style': drawerHeight.value ? { height: `${drawerHeight.value}px` } : null
                        })
                    );
                }),
                (__$blocks['_content'] = function($super, data) {
                    var block = $blocks['_content'];
                    var callBlock = function() {
                        return _$blocks['_content'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                })
            ),
            __$blocks
        );
    }.call($this, $blocks), $__proto__);
};